import { z } from "zod";

export enum InviteApprovalType {
  Owner = "owner",
  None = "none",
}

export const inviteApprovalTypeZod = z.enum(["owner", "none"]);
